




import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class CzTitle extends Vue {
  @Prop({ type: String, default: "h1" }) tag!: string;
  @Prop({ type: String, default: "page" }) size!: "page" | "card" | "section" | "item";
}
